<template>
  <div class="pdfView">
    <van-sticky v-if="!isEdit">
      <div
        class="pdfViewNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">查看PDF</span>
      </div>
    </van-sticky>
    <div class="stepper-warpper" v-show="!isEdit">
      <van-stepper
        v-model="value"
        input-width="40px"
        step="0.2"
        :decimal-length="1"
        :disabled="isDisabled"
        @change="stepperOnchange"
      />
      <div class="percent">{{ percentValue }}</div>
    </div>
    <div class="contentBox">
      <div id="contidract" :style="contidractStyle" ref="contidract">
        <div :style="pdfStyle" ref="pdfbox">
          <pdf
            v-for="i in numPages"
            :key="i"
            :src="pdfSrc"
            :page="i"
            ref="pdfs"
            @loaded="pdfLoaded(i)"
            :style="{ width: '100%' }"
          >
          </pdf>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  props: {
    isEdit: {
      default: false,
    },
    pdfUrl: {
      default: "",
    },
  },
  data() {
    return {
      isiOSX: false,
      pdfStyle: { "transform-origin": "left top" },
      contidractStyle: { "background-color": "#E3E3E3", height: "100%" },
      numPages: undefined,
      pdfSrc: "",
      data: {},
      value: 1,
      isDisabled: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    setTimeout(() => {
      this.onLoad();
    }, 200);
  },
  mounted() {},
  components: {
    pdf,
  },
  computed: {
    percentValue() {
      return parseInt(parseFloat(this.value) * 100) + "%";
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onLoad() {
      if (this.isEdit) {
        this.pdfSrc = location.protocol + "//" + this.pdfUrl.split("//")[1];
      } else {
        this.pdfSrc =
          location.protocol + "//" + this.$route.query.pdfSrc.split("//")[1];
      }
      this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
      this.pdfSrc.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
        })
        .catch((res) => {
          console.log("pdf加载失败");
        });
    },
    async pdfLoaded(i) {
      if (this.numPages !== i) {
        return;
      }
    },
    stepperOnchange() {
      this.$nextTick(() => {
        this.pdfStyle.transform = `scale(${this.value})`;
        // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
        this.$refs.pdfbox.style.display = "none";
        this.isDisabled = true;
        setTimeout(() => {
          // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
          this.$refs.pdfbox.style.display = "block";
        }, 10);
        setTimeout(() => {
          this.isDisabled = false;
        }, 200);
      });
    },
    parentStepperOnchange(value) {
      this.value = value;
      this.stepperOnchange();
    },
  },
};
</script>
<style lang="less">
.pdfView {
  min-height: 100%;
  background: #f2f2f2;
  .pdfViewNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  #contidract {
    &::-webkit-scrollbar {
      display: none;
    }
    overflow: scroll;
    position: relative;
  }
  .stepper-warpper {
    height: 28px;
    position: relative;
    background-color: #fff;
    .van-stepper {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .percent {
      position: absolute;
      height: 28px;
      line-height: 28px;
      width: 40px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      background-color: #f2f3f5;
      font-size: 13px;
    }
  }
}
</style>